import { Chart } from 'primereact/chart';
import Section from '../../../../components/Display/Section';

function VisitsBarChart({ data, title, message }) {
  const chartOptions = {
    scales: {
      x: {
        stacked: true
      },
      y: {
        stacked: true
      }
    }
  };

  return (
    <Section label={title}>
      {message && <span className="text-sm text-slate-500">{message}</span>}
      <Chart type="bar" data={data} options={chartOptions} className="h-[400px]" />
    </Section>
  );
}

export default VisitsBarChart;
